// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev config which uses `config.ts`, but if you do
// `ng build --env=prod` then `config.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: true,
  zuul_uri: window['env']['api.url'] || 'http://localhost:5555',
  oidc: {
    enable: window['env']['oidc.enable'] || 'false',
    authority: window['env']['oidc.authority'],
    redirectUrl: window['env']['oidc.redirectUrl'],
    clientId: window['env']['oidc.clientId'],
    postLogoutRedirectUri: window['env']['oidc.postLogoutRedirectUri'] || window.location.origin
  }
};
